export default "__VITE_ASSET__B7PQPL78__"